import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about-section">
      <h2 className="section-title">About Me</h2>
      <div className="about-content glass-panel">
        <div className="about-text">
          <p>
            Hello! I am <strong>Marcus Yap Kwan Rui</strong>, a final-year Computer Science student at the National University of Singapore (NUS), currently pursuing a Second Major in Quantitative Finance. My academic focus areas are Artificial Intelligence and Computer Security.
          </p>
          <p>
            Throughout my academic journey and professional experiences, I've developed a deep interest in the intersection of Data, Machine Learning, and Cyber Risk & Governance. I thrive on translating technical concepts into actionable risk insights and building intelligent systems that solve complex problems.
          </p>
          <p>
            When I am not coding or participating in hackathons, I enjoy mentoring students and exploring the mathematical frameworks that drive financial markets and reinforcement learning.
          </p>
        </div>
        
        <div className="education-timeline">
          <h3 className="subsection-title">Education</h3>
          <div className="timeline-item">
            <div className="timeline-dot"></div>
            <h4>National University of Singapore</h4>
            <span className="timeline-date">Aug 2022 - May 2026</span>
            <p>Bachelor of Computing in Computer Science (Hons)</p>
            <p className="minor-text">Second Major in Quantitative Finance | Focus: AI & Computer Security</p>
          </div>
          <div className="timeline-item">
            <div className="timeline-dot"></div>
            <h4>Korea University</h4>
            <span className="timeline-date">Winter Exchange (2023, 2024, 2025)</span>
            <p>A+ for Principles of Financial Accounting & Micro Economics</p>
          </div>
          <div className="timeline-item">
            <div className="timeline-dot"></div>
            <h4>Ngee Ann Polytechnic</h4>
            <p>Diploma with Merit in Aerospace Technology</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
